import { LoadingPlaceholder } from 'mk2/components/LoadingPlaceholder';
import React from 'react';
import styles from './PostPlaceholder.mscss';

interface PlaceholderOwnProps {
    style?: any;
    isLast?: boolean;
    isMobile: boolean;
    bannerAd?: React.ReactNode;
}

const PostEntryPlaceholder: React.StatelessComponent<PlaceholderOwnProps> = ({ style, bannerAd, isMobile }) => (
    <div className={styles.PostEntryPlaceholder} style={style}>
        <div className={styles.PostEntryPlaceholder__body}>
            <div className={styles.PostEntryPlaceholder__body__meta}>
                <LoadingPlaceholder width={isMobile ? '50%' : '20%'}/>
            </div>
            {bannerAd}
            <div className={styles.PostEntryPlaceholder__body__text}>
                <div className={styles.PostEntryPlaceholder__body__text__heading}>
                    <LoadingPlaceholder width="70%" height={18} />
                </div>
                <div className={styles.PostEntryPlaceholder__body__text__perex}>
                    <LoadingPlaceholder width="95%" />
                    <LoadingPlaceholder width="95%" />
                    {isMobile &&
                        <div>
                            <LoadingPlaceholder width="95%" />
                            <LoadingPlaceholder width="95%" />
                        </div>
                    }
                </div>
            </div>
        </div>
        <div className={styles.PostEntryPlaceholder__footer}>
            <div className={styles.PostEntryPlaceholder__footer__likes}>
                <LoadingPlaceholder width={40} height={20} />
            </div>
            {isMobile && <hr className={styles.PostEntryPlaceholder__footer__line} />}
            <div className={styles.PostEntryPlaceholder__footer__comments}>
                <LoadingPlaceholder width={40} height={20} />
            </div>
        </div>
    </div>
);
PostEntryPlaceholder.displayName = 'PostEntryPlaceholder';

export default PostEntryPlaceholder;
